export const ROUTE_PAGE = {
  API_REQUEST_HISTORY: '/api-request-history',
  CHART_ANALYTIC: '/chart-analytic',
  INSPECTION_ITEM_LIST: '/inspection-item-list',
  TENANT_MANAGEMENT: '/tenant-management',
  PRODUCT_MANAGEMENT: '/product-management',
  TENANT_DOMAIN: '/tenant-domains',
  CUSTOMIZE_DISPLAY_FOR_PRODUCT: '/customize-display-for-product',
  CUSTOMIZE_DISPLAY_SETTING: '/customize-display-for-product/setting',
  ANALYTICS_REQUESTS: '/analytics-requests',
  ANALYTICS_REQUEST_DETAIL: '/analytics-requests/:id',
  UPLOAD_USER_TEST_DATA: '/upload-user-test-data',
}

// Route Permission Utilities
export const getUserRole = (isMaster: boolean, isTenant: boolean): 'masterTenant' | 'tenant' | 'user' => {
  if (isMaster) return 'masterTenant'
  if (isTenant) return 'tenant'
  return 'user'
}

export const hasRoutePermission = (
  routePath: string, 
  routesConfig: any[], 
  userRole: 'masterTenant' | 'tenant' | 'user'
): boolean => {
  // Find the route configuration that matches the given path
  const routeConfig = routesConfig.find(route => {
    // Handle exact matches first
    if (route.path === routePath) return true
    
    // Handle base paths (remove parameters)
    const basePath = route.path.split(':')[0].replace(/\/$/, '')
    const baseRoutePath = routePath.split(':')[0].replace(/\/$/, '')
    
    return basePath === baseRoutePath
  })

  if (!routeConfig) return false

  return routeConfig.allowedRoles.includes(userRole)
}

export const isRouteAccessible = (
  routePath: string,
  routesConfig: any[],
  isMaster: boolean,
  isTenant: boolean
): boolean => {
  const userRole = getUserRole(isMaster, isTenant)
  return hasRoutePermission(routePath, routesConfig, userRole)
}